import React, { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { User, Save } from 'lucide-react';
import DashboardLayout from '../components/DashboardLayout';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Select } from '../components/ui/select';
import api from '../utils/api';

const ORG_TYPES = ['CA Firm', 'Individual CA', 'Audit Firm', 'Tax Consultancy', 'Accounting Firm', 'Other'];

export default function SettingsPage() {
  const [profile, setProfile] = useState({ full_name: '', phone: '', organization_type: 'CA Firm' });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get('/profile')
      .then(r => { if (r.data) setProfile(p => ({ ...p, ...r.data })); })
      .catch(() => toast.error('Failed to load profile'))
      .finally(() => setLoading(false));
  }, []);

  const handleSave = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await api.put('/profile', {
        full_name: profile.full_name,
        phone: profile.phone,
        organization_type: profile.organization_type,
      });
      toast.success('Profile updated successfully');
    } catch {
      toast.error('Failed to save profile');
    } finally {
      setSaving(false);
    }
  };

  return (
    <DashboardLayout>
      <div className="max-w-2xl">
        <div className="mb-6">
          <h1 className="text-2xl font-bold text-slate-900 dark:text-slate-100">Settings</h1>
          <p className="text-slate-500 dark:text-slate-400 text-sm mt-1">Manage your account profile</p>
        </div>

        <Card>
          <CardHeader>
            <div className="flex items-center gap-2">
              <User className="w-5 h-5 text-sky-600" />
              <CardTitle>Profile Information</CardTitle>
            </div>
          </CardHeader>
          <CardContent>
            {loading ? (
              <div className="space-y-4">
                {[1, 2, 3].map(i => (
                  <div key={i} className="h-9 bg-slate-100 dark:bg-slate-800 rounded-md animate-pulse" />
                ))}
              </div>
            ) : (
              <form onSubmit={handleSave} className="space-y-5">
                <Input
                  label="Full Name"
                  value={profile.full_name || ''}
                  onChange={(e) => setProfile(p => ({ ...p, full_name: e.target.value }))}
                  placeholder="CA Rajesh Kumar"
                />
                <Input
                  label="Phone Number"
                  type="tel"
                  value={profile.phone || ''}
                  onChange={(e) => setProfile(p => ({ ...p, phone: e.target.value }))}
                  placeholder="+91 98765 43210"
                />
                <Select
                  label="Organization Type"
                  value={profile.organization_type || 'CA Firm'}
                  onChange={(e) => setProfile(p => ({ ...p, organization_type: e.target.value }))}
                >
                  {ORG_TYPES.map(t => <option key={t} value={t}>{t}</option>)}
                </Select>
                <div className="pt-2">
                  <Button type="submit" loading={saving} className="gap-2">
                    <Save className="w-4 h-4" />
                    {saving ? 'Saving…' : 'Save Changes'}
                  </Button>
                </div>
              </form>
            )}
          </CardContent>
        </Card>
      </div>
    </DashboardLayout>
  );
}
